import { useSelector } from 'react-redux';
import { KITCHEN_LOCATIONS } from '../constants/restaurants.constants';

export const useKitchenLocations = () => {
  const { restaurantsWithoutSelect, restaurantUuid } = useSelector((state) => state.login);
  const restaurant = restaurantsWithoutSelect.find(({ value }) => value === restaurantUuid);
  return restaurant ? restaurant.kitchenLocations : Object.values(KITCHEN_LOCATIONS);
};
